import React from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import bannerVideo from "../Assets/videos/bannervideo.mp4";
import "./VideoSection.css";

const VideoSection = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView({ threshold: 0.3, triggerOnce: true });

  React.useEffect(() => {
    if (inView) {
      controls.start({
        opacity: 1,
        scale: 1,
        rotateX: 0,
        transition: { duration: 2, ease: "easeOut" },
      });
    }
  }, [inView, controls]);

  return (
    <motion.div
      className="video-section"
      ref={ref}
      initial={{ opacity: 0, scale: 0.8, rotateX: 35 }}
      animate={controls}
    >
      <video autoPlay muted loop className="video-element" playsInline>
        <source src={bannerVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

    </motion.div>
  );
};

export default VideoSection;
